import Constants from "Components/MessageToaster/Constants";
import { IAreaController } from "Interfaces/Controllers/IAreaController";
import { inject, injectable } from "inversify";
import { Area } from "Models/Areas/Area";
import { Dispatch } from "react";
import Types from "ServiceProvider/Types";
import { ActionTypes as MessageActionTypes, IShowMessageToasterAction } from "Store/MessageToaster/MessageToasterActionTypes";
import i18n from "Translations/i18n";
import { ActionTypes, IAreasRetrievedAction } from "./AreaActionTypes";

export interface IAreaAction {
    getAreasByCompanyId(): any;
}

@injectable()
export class AreaAction implements IAreaAction {
    private areaController: IAreaController;

    public constructor(
        @inject(Types.IAreaController) areaController: IAreaController) {
        this.areaController = areaController;
    }

    public getAreasByCompanyId(): any {
        return async (dispatch: Dispatch<IAreasRetrievedAction | IShowMessageToasterAction>) => {
            try {
                const companyAreas = await this.areaController.getAreasForCompanyAsync();

                const setParentForAllChildren = (area: Area) => {
                    if (area.children) {
                        area.children.forEach(child => {
                            child.parent = area;
                            setParentForAllChildren(child);
                        });
                    }
                };
                companyAreas.forEach(setParentForAllChildren);

                dispatch({
                    type: ActionTypes.AREAS_RETRIEVED,
                    data: companyAreas
                });
            }
            catch (ex) {
                dispatch({
                    type: MessageActionTypes.SHOW_MESSAGE,
                    data: { type: Constants.MESSAGE_TYPE_DANGER, text: i18n.t("areas.errors.retrieving") }
                });
            }
        };
    }
}


// WEBPACK FOOTER //
// ./src/Store/Areas/AreaAction.ts